// extracted by css-extract-rspack-plugin
export default {"default-header":"D1vg6v1VEiN_Dst3","defaultHeader":"D1vg6v1VEiN_Dst3","default-text":"mJwxL0N8Amkpmd96","defaultText":"mJwxL0N8Amkpmd96"};